import { render, staticRenderFns } from "./platform_notice_add.vue?vue&type=template&id=1e60a810"
import script from "./platform_notice_add.vue?vue&type=script&lang=js"
export * from "./platform_notice_add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports